import React from 'react';
import { motion } from 'framer-motion';
import { Smartphone, Download } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO';

const Uygulama: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <SEO
        title={t('support:app.seoTitle')}
        description={t('support:app.seoDescription')}
        url="/diger/uygulama"
      />
      <div className="min-h-screen bg-dark-900 pt-24 pb-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <div className="w-20 h-20 mx-auto mb-6 rounded-xl bg-gradient-to-r from-green-500 to-emerald-500 flex items-center justify-center">
              <Smartphone className="w-10 h-10 text-white" />
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
              {t('support:app.title')}
            </h1>
            <p className="text-xl text-gray-400 max-w-2xl mx-auto">
              {t('support:app.description')}
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="bg-dark-800/50 backdrop-blur-sm rounded-2xl p-8 border border-dark-700 text-center"
          >
            <Download className="w-16 h-16 text-primary-400 mx-auto mb-4" />
            <h2 className="text-2xl font-bold text-white mb-4">{t('support:app.comingSoon')}</h2>
            <p className="text-gray-400">
              {t('support:app.stayTuned')}
            </p>
          </motion.div>
        </div>
      </div>
    </>
  );
};

export default Uygulama;
